import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'dte/:gen_code',
    loadChildren: () => import('./dte/dte.module').then(m => m.DtePageModule)
  },
  {
    path: 'dte/:account_key/:ticket_key',
    loadChildren: () => import('./pages/account-dte/account-dte.module').then(m => m.AccountDtePageModule)
  },
  {
    path: 's/:accountKey/loyalty/:token',
    loadChildren: () => import('./pages/loyalty-card/loyalty-card.module').then(m => m.LoyaltyCardPageModule)
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
